/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderSchema } from "./repeatMobileOrderSchema.ts";
import { requestRepeatMobileOrderRequestSchema } from "./requestRepeatMobileOrderRequestSchema.ts";

export const orderRepeatCreateStatus200Schema = repeatMobileOrderSchema;

export const orderRepeatCreateResponseSchema = orderRepeatCreateStatus200Schema;

export const orderRepeatCreateDataSchemaJson = requestRepeatMobileOrderRequestSchema;

export const orderRepeatCreateDataSchemaXml = requestRepeatMobileOrderRequestSchema;

export const orderRepeatCreateDataSchema = z.union([orderRepeatCreateDataSchemaJson, orderRepeatCreateDataSchemaXml]);
